import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const BATCH_STYLES = {
  REVIEW: "bg-blue-50 text-[#008080] border-blue-200",
  PENDING_APPROVAL: "bg-purple-50 text-purple-700 border-purple-200",
  RETURNED: "bg-amber-50 text-amber-800 border-amber-200",
  APPROVED: "bg-teal-50 text-teal-700 border-teal-200",
  EXECUTED: "bg-indigo-50 text-indigo-700 border-indigo-200",
  CLOSED: "bg-slate-200 text-slate-700 border-slate-300",
  CANCELLED: "bg-slate-100 text-slate-500 border-slate-200",
};
export const RULE_STYLES = {
  DRAFT: "bg-slate-100 text-slate-600 border-slate-200",
  PENDING_APPROVAL: "bg-purple-50 text-purple-700 border-purple-200",
  ACTIVE: "bg-emerald-50 text-emerald-700 border-emerald-200",
  RETIRED: "bg-slate-200 text-slate-500 border-slate-300",
};
export const HOLD_STYLES = {
  LEGAL: "bg-red-600 text-white", INVESTIGATION: "bg-amber-500 text-white", TAX: "bg-[#003366] text-white",
};
export const DISPOSITION_STEPS = [["REVIEW", "Review queue"], ["PENDING_APPROVAL", "Approve"], ["EXECUTED", "Execute"], ["CLOSED", "Close"]];

let cache = null;
export const useRetentionMeta = () => {
  const [meta, setMeta] = useState(cache);
  const reload = useCallback(() => api.get("/retention/meta").then(({ data }) => { cache = data; setMeta(data); }).catch(() => {}), []);
  useEffect(() => { if (!cache) reload(); }, [reload]);
  return meta;
};

export const Pill = ({ cls, children, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[11px] font-semibold whitespace-nowrap ${cls}`}>{children}</span>
);
